import { Link, type LinkProps } from '@mui/material'
import React from 'react'

export const MUIExternalLink: React.FC<LinkProps> = ({ children, ...rest }) => {
  return (
    <Link rel="noopener noreferrer nofollow" target="_blank" {...rest}>
      {children}
    </Link>
  )
}
